import React, {useState} from 'react';
import {Col, Container, Modal, Row} from "reactstrap";
import { withRouter } from "react-router-dom";

const queryString = require('query-string');
const parsed = queryString.parse(window.location.search);
const lang = (parsed.lang ? parsed.lang.toLowerCase() : null) || 'en';

const content = {
  en: <div className="steps">
    <div className="step">
      <div className="step-number">1</div>
      <div className="step-description">
        <p>To set up the screen recording function on your phone go to <b>Settings</b> {">"} <b>Control Center</b>.</p>
      </div>
    </div>
    <div className="step">
      <div className="step-number">2</div>
      <div className="step-description">
        <p>Scroll down to <b>More Controls</b>.</p>
        <p><i>If you have iOS 13 or earlier tap Customise Controls.</i></p>
      </div>
    </div>
    <div className="step">
      <div className="step-number">3</div>
      <div className="step-description">
        <p>Tap the <b>Add button</b> next to <b>Screen Recording</b>.</p>
      </div>
    </div>
    <div className="step">
      <div className="step-number">4</div>
      <div className="step-description">
        <p>To start recording, open the <b>Control Centre</b> on your iPhone.</p>
        <p><i>To open Control Centre, swipe down from the top right-hand corner of your screen.</i></p>
        <p><i>To close Control Centre, swipe up from the bottom of the screen or tap the screen.</i></p>
      </div>
    </div>
    <div className="step">
      <div className="step-number">5</div>
      <div className="step-description">
        <p>Tap the <b>grey record icon</b> so it turns red and swipe the Control Centre closed.</p>
      </div>
    </div>
    <div className="step">
      <div className="step-number">5</div>
      <div className="step-description">
        <p>When you have captured everything you need on your screen open <b>Control Centre</b> and then tap the <b>red Record button</b>.</p>
      </div>
    </div>
  </div>,

es: <div className="steps">
<div className="step">
  <div className="step-number">1</div>
  <div className="step-description">
  <p>Para configurar la función de grabación de pantalla en su teléfono, vaya a <b>Configuración</b> {">"} <b>Centro de control</b>.</p>
  </div>
</div>
<div className="step">
  <div className="step-number">2</div>
  <div className="step-description">
    <p>Desplácese hacia abajo hasta <b>Más controles</b>.</p>
    <p><i>Si tienes iOS 13 o una versión anterior, toca Personalizar controles.</i></p>
  </div>
</div>
<div className="step">
  <div className="step-number">3</div>
  <div className="step-description">
    <p>Toca el <b>botón Agregar</b> junto a <b>Grabación de pantalla</b>.</p>
  </div>
</div>
<div className="step">
  <div className="step-number">4</div>
  <div className="step-description">
    <p>Para comenzar a grabar, abre el <b>Centro de control</b> de tu iPhone.</p>
    <p><i>Para abrir el Centro de control, deslízate hacia abajo desde la esquina superior derecha de la pantalla.</i></p>
    <p><i>Para cerrar el Centro de control, deslízate hacia arriba desde la parte inferior de la pantalla o toca la pantalla.</i></p>
  </div>
</div>
<div className="step">
  <div className="step-number">5</div>
  <div className="step-description">
    <p>Toca el <b>icono de registro gris</b> para que se vuelva rojo y desliza el Centro de control para cerrarlo.</p>
  </div>
</div>
<div className="step">
  <div className="step-number">5</div>
  <div className="step-description">
    <p>Cuando hayas capturado todo lo que necesitas en tu pantalla, abre el <b>Centro de control</b> y luego tocael <b>botón rojo Grabar</b>.</p>
  </div>
</div>
</div>,

pt: <div className="steps">
<div className="step">
  <div className="step-number">1</div>
  <div className="step-description">
    <p>Para configurar a função de gravação de tela no seu telefone, vá para <b>Configurações</b> {">"} <b>Central de Controle</b>.</p>
  </div>
</div>
<div className="step">
  <div className="step-number">2</div>
  <div className="step-description">
    <p>Role para baixo até <b>Mais controles</b>.</p>
    <p><i>Se você tiver iOS 13 ou anterior, toque em Personalizar controles.</i></p>
  </div>
</div>
<div className="step">
  <div className="step-number">3</div>
  <div className="step-description">
    <p>Toque no botão <b>Adicionar</b> ao lado de <b>Gravação de tela</b>.</p>
  </div>
</div>
<div className="step">
  <div className="step-number">4</div>
  <div className="step-description">
    <p>Para iniciar a gravação, abra a <b>Central de Controle</b> no seu iPhone.</p>
    <p><i>Para abrir a Central de Controle, deslize para baixo a partir do canto superior direito da tela.</i></p>
    <p><i>Para fechar a Central de controle, deslize de baixo para cima na tela ou toque na tela.</i></p>
  </div>
</div>
<div className="step">
  <div className="step-number">5</div>
  <div className="step-description">
    <p>Toque no <b>ícone de registro cinza</b> para que ele fique vermelho e deslize o Centro de Controle para fechá-lo.</p>
  </div>
</div>
<div className="step">
  <div className="step-number">5</div>
  <div className="step-description">
  <p>Quando tiver capturado tudo o que precisa na tela, abra a <b>Central de Controle</b> e toque emo <b>botão vermelho Gravar</b>.</p>
  </div>
</div>
</div>,

id: <div className="steps">
<div className="step">
  <div className="step-number">1</div>
  <div className="step-description">
    <p>Untuk menyiapkan fungsi perekaman layar di ponsel Anda, buka <b>Setelan</b> {">"} <b>Pusat Kontrol</b>.</p>
  </div>
</div>
<div className="step">
  <div className="step-number">2</div>
  <div className="step-description">
    <p>Gulir ke bawah ke <b>Kontrol Lainnya</b>.</p>
    <p><i>Jika Anda memiliki iOS 13 atau versi lebih lama, ketuk Sesuaikan Kontrol.</i></p>
  </div>
</div>
<div className="step">
  <div className="step-number">3</div>
  <div className="step-description">
    <p>Ketuk <b>tombol Tambah</b> di samping <b>Rekaman Layar</b>.</p>
  </div>
</div>
<div className="step">
  <div className="step-number">4</div>
  <div className="step-description">
    <p>Untuk mulai merekam, buka <b>Pusat Kontrol</b> di iPhone Anda.</p>
    <p><i>Untuk membuka Pusat Kontrol, geser ke bawah dari sudut kanan atas layar Anda.</i></p>
    <p><i>Untuk menutup Pusat Kontrol, geser ke atas dari bawah layar atau ketuk layar.</i></p>
  </div>
</div>
<div className="step">
  <div className="step-number">5</div>
  <div className="step-description">
    <p>Ketuk <b>ikon rekaman berwarna abu-abu</b> hingga berubah menjadi merah dan geser Pusat Kontrol hingga tertutup.</p>
  </div>
</div>
<div className="step">
  <div className="step-number">5</div>
  <div className="step-description">
    <p>Setelah Anda menangkap semua yang Anda perlukan di layar, buka <b>Pusat Kontrol</b> lalu ketuk <b>tombol Rekam merah</b>.</p>
  </div>
</div>
</div>,
}

function ScreenRecordingInstructionsIOS({history}) {
  const [videoModal, setVideoModal] = useState(false);
  const toggleVideoModal = () => setVideoModal(!videoModal);

  // we have to set the height in JavaScript because viewport height is weird on mobile
  const videoHeight = window.innerHeight - 100;

  return (
    <Container fluid="sm" className="retro-instructions">
      <Row>
        <Col>
          {lang === "en" || !lang
            ? <>
              <div className="video-thumbnail no-content-above">
                <video
                  controls
                  className="instructions-video inline-landscape-video"
                  poster="https://d3s00xghdjywqy.cloudfront.net/c2/retro/ios-screen-recording/How_To_Screen_Record_Thumbnail.gif"
                >
                    <source src="https://d3s00xghdjywqy.cloudfront.net/c2/retro/ios-screen-recording/How_To_Screen_Record.mp4" type="video/mp4" />
                    Your browser does not support videos, sorry.
                </video>
              </div>
              <Modal className="instructions-video-modal" centered isOpen={videoModal} toggle={toggleVideoModal}>
                <div className="video-container">
                  <video
                    controls
                    className="instructions-video"
                    height={videoHeight}
                    playsInline={true}
                    poster="https://d3s00xghdjywqy.cloudfront.net/c2/retro/ios-screen-recording/How_To_Screen_Record_Poster.jpg"
                  >
                    <source src="https://d3s00xghdjywqy.cloudfront.net/c2/retro/ios-screen-recording/How_To_Screen_Record.mp4" type="video/mp4" />
                    Your browser does not support videos, sorry.
                  </video>
                </div>
              </Modal>
            </>
            : null
          }
          
          {content[lang] ?? content.en}

          <div className="action-button">
            <span className="btn btn-primary" onClick={() => history.goBack()}>Done</span>
          </div>

        </Col>
      </Row>
    </Container>
  );
}

export default withRouter(ScreenRecordingInstructionsIOS);
